module.exports = __webpack_public_path__ + "img/dongji_ps_25.1a808d16.jpg";